import { useHistory } from "react-router-dom";
import CustomText from "../atomic/CustomText";
import Button from "../organism/Button";
import { useContext, useEffect } from "react";
import { PopUpContext } from "../../services/context/popupContext";
import OnlineOrderActions from "../../services/OnlineOrderActions";

function OnlineOrderSelectionFlow({
  orderActions,
  isUpdate,
}: {
  orderActions: OnlineOrderActions;
  isUpdate?: boolean;
}): JSX.Element {
  const history = useHistory();
  const { setVisible, setOnlineOrder, setPopUpTitle } =
    useContext(PopUpContext);

  useEffect(() => {
    let popupTitle = isUpdate ? "Update Online Order" : "Online Order";
    setOnlineOrder?.(true);
    setPopUpTitle(popupTitle);
  }, []);

  return (
    <div className="flex flex-col">
      <CustomText
        text={orderActions.popUpText()}
        fontWeight="font-normal"
        className="text-requiredRed"
      />
      <Button
        buttonTheme="primary"
        textInformation={{ text: "Ok", fontWeight: "font-semibold" }}
        onClick={() => {
          history.replace("/access/test-orders");
          setVisible(false);
          setOnlineOrder?.(false);
        }}
        className=" self-end mt-4"
      />
    </div>
  );
}

export default OnlineOrderSelectionFlow;
